import { IApplicationState } from 'setup/store'

import { defaultCurrency } from 'shared/constants'

export const selectIsUserAuthenticated = (state: IApplicationState) => state.auth.data.isAuth

export const selectAuthCommunication = (state: IApplicationState) => state.auth.communications

export const selectUserData = (state: IApplicationState) => state.auth.data.user

export const selectAgentLinks = (state: IApplicationState) => state.auth.data.agentLinks

export const selectUserCurrrency = (state: IApplicationState) => state.auth.data.user?.currency ?? defaultCurrency

export const selectSessionData = (state: IApplicationState) => state.auth.data.session

export const selectRefreshSessionCommunications = (state: IApplicationState) => state.auth.communications.refreshSession
